import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_related_to_m'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_related_to_m',
  name: 'Does the facility follow any of the following practices related to maintaining payroll records:',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PAYROLL_RECORDS_FOR_EACH_WORKER_ARE_MAINTAINED_FOR_AT_LEAST_THE',
      text: 'Payroll records for each worker are maintained for at least the last 12 months',
      externalIds: [
        {
          id: 'wb-2--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PAYROLL_RECORDS_ARE_CONSISTENT_WITH_ATTENDANCE_RECORDS_AND_OTHE',
      text: 'Payroll records are consistent with attendance records and other records',
      externalIds: [
        {
          id: 'wb-2--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wb-2--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PAYROLL_RECORDS_FOR_EACH_WORKER_ARE_MAINTAINED_FOR_AT_LEAST_THE',
                'PAYROLL_RECORDS_ARE_CONSISTENT_WITH_ATTENDANCE_RECORDS_AND_OTHE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7240,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
